import React from 'react'
import { Link } from "react-router-dom";

import logo2 from '../food.jpg'

export default function Navbar() {
    return (
        <nav className="text-white h-10 font-mono ">
            <div className="bg-purple-300 text-white h-10 flex flex-row items-start justify-between sm:items-center sm:justify-around">
                <img src={logo2} alt="logo" className="h-10 ml-5 bg-blue-900" />
                <ul className="text-purple-900 text-2xl font-bold flex flex-row justify-between sm:ml-10 ">
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li className="mx-20 ">
                        <Link to="/about">About</Link>
                    </li>
                </ul>
            </div>
        </nav>
    )
}
